
import { View } from 'backbone';
import eventBus         from 'EventBus.js';
import listService  from 'ListService'
import nameTemplate from 'report/properties/main/chart-data.ejs';
import MainFormulaModal from 'common-views/MainFormulaModalView.js';
import util from 'util/Util.js';


class MainChartDataView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #dataSource' :'updateDataSource'
        };


        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateDataSource(ev){

        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;

        let lastSourceId=this.model.get('dataSourceId');

        let ds = listService.getDataSources(lastSourceId);

        if(ds && ds.uses){
            ds.uses -= 1;
        }

        listService.deleteReportMetaData( this.model.get('id'));


        if (propVal !== 'none' && propVal !== 'null') {
            // Set new MetaData
            listService.setReportingMetaData(propVal, this.model, true);
        }
        if ((this.model.get('factoryKey') === 'control_clear_filter' || this.model.get('factoryKey') === 'control_set_filter') && this.model.get('autosummaryChecked')) {
            let optionSelected=$(ev.currentTarget).find(`option[value="${propVal}"]`).text();
            if(optionSelected === 'None'){
                optionSelected = ''
            }
            this.model.set('widgetText',optionSelected,{silent:true});
        }

        let columnFields = this.model.get('Columns');
        if (columnFields) {
            if (columnFields.Column) {
                _.forEach(columnFields.Column, column => column.Properties.fieldId = "");
            }            
        }
        // always assing the original datasource id
        this.model.set( propName, listService.getCleanedId(propVal) );
        if ( this.model.get('factoryKey') === 'control_set_filter' && propVal !=='none' ) {
                eventBus.trigger('updateOperator'+ this.model.get('id') );
        }
    }

    populateDataSources() {
        const elDataSources = $('#dataSource');
        if (elDataSources) {
            //elDataSources.empty();
            const ds = listService.getDataSources();
            ds.map((v, k) => {
                elDataSources[0].options[elDataSources[0].options.length] = new Option(v.name, v.id);
            });
        }
    }

    render() {
        
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.populateDataSources();

        let currentDataSourceId = this.model.get('dataSourceId');
        let dataSourceList = $('#dataSource'); 

        if (!util.isEmpty(currentDataSourceId)) {
            currentDataSourceId = listService.cleanId(currentDataSourceId);
        }
        else if (util.isEmpty(currentDataSourceId)) {
            let firstDataSource = listService.getDataSources().first();
            currentDataSourceId = firstDataSource ? listService.cleanId(firstDataSource.id) : undefined;
            // Always assign original id to the model
            this.model.set('dataSourceId', listService.getCleanedId(currentDataSourceId), { silent: true });
            listService.setReportingMetaData(currentDataSourceId, this.model, true); 
        }
 
        dataSourceList.find('option[value=' + currentDataSourceId + ']').attr('selected', true);

        this.delegateEvents();
        return this;
    }
}

export default MainChartDataView;
